export const ELIGIBILITY_WARNING_REASON = {
  'MPE-WARN-MOT-AND-TAX-NEED-RENEWING': 'MPE-WARN-MOT-AND-TAX-NEED-RENEWING',
  'MPE-WARN-MOT-NEEDS-RENEWING': 'MPE-WARN-MOT-NEEDS-RENEWING',
  'MPE-WARN-TAX-NEEDS-RENEWING': 'MPE-WARN-TAX-NEEDS-RENEWING',
};

export const ELIGIBILITY_ERROR_REASON = {
  UNSELLABLE_WO: 'MPE-ERR-VS-001',
};

export type EligibilityFailedReason =
| typeof ELIGIBILITY_WARNING_REASON[keyof typeof ELIGIBILITY_WARNING_REASON]
| typeof ELIGIBILITY_ERROR_REASON[keyof typeof ELIGIBILITY_ERROR_REASON];

export type EligibilityStatus = {
    eligible: boolean;
    reasonCode?: EligibilityFailedReason;
}

export type EnhancedEligibilityContextTypes = {
  isEligible?: boolean;
  isIneligibleWO?: boolean;
  isLoading: boolean;
  reasonCode?: EligibilityFailedReason;
}
